import { render } from "./Slider.view.vue?vue&type=template&id=678b00c9"
import script from "./Slider.view.vue?vue&type=script&lang=js"
export * from "./Slider.view.vue?vue&type=script&lang=js"

import "./Slider.view.vue?vue&type=style&index=0&id=678b00c9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__